import { useViewStore } from '../../stores/viewStore'

const toggles = [
  { key: 'zonesVisible', label: 'Zones', action: 'toggleZones' },
  { key: 'wallsVisible', label: 'Murs', action: 'toggleWalls' },
  { key: 'floorplansVisible', label: 'Plans', action: 'toggleFloorplans' },
  { key: 'ifcWallsVisible', label: 'Murs IFC', action: 'toggleIFCWalls' },
  { key: 'pathSegmentsVisible', label: 'Chemins', action: 'togglePathSegments' },
  { key: 'occupantsVisible', label: 'Occupants', action: 'toggleOccupants' },
] as const

export default function DisplayToggles() {
  const store = useViewStore()

  return (
    <div className="display-toggles">
      <div className="panel-section__title">Affichage</div>
      {toggles.map(({ key, label, action }) => (
        <label key={key} className="display-toggles__item">
          <input
            type="checkbox"
            checked={store[key]}
            onChange={() => (store[action] as () => void)()}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  )
}
